import { FC, useContext, useEffect, useState, useCallback } from "react";
import { Context } from "../../..";
import "./SettingsPopup.css";
import { useNavigate } from "react-router-dom";
import ExitButton from "../../buttons/ExitButton/ExitButton";
import Avatar, { AvatarSize } from "../../Shared/Avatar/Avatar";
import useOutsideAlerter from "../../../hooks/useOutsideAlert";
import { AppContext } from "../../../App";
import { AxiosError } from "axios";

interface ISettingsPopupProps {
    onClose: () => void;
    onSettingsClick: () => void;
    onPasswordChangeClick: () => void;
}

interface VersionData {
    appVersion?: string;
}

const SettingsPopup: FC<ISettingsPopupProps> = ({
    onClose,
    onSettingsClick,
    onPasswordChangeClick
}) => {
    const { store } = useContext(Context);
    const { showToast } = useContext(AppContext)
    const navigate = useNavigate();
    const outsideAlerterRef = useOutsideAlerter<HTMLDivElement>(onClose);
    const [version, setVersion] = useState<VersionData>({});

    const fetchVersion = useCallback(async () => {
        try {
            const data = await store.getVersion();
            setVersion(data);
        } catch (error) {
            if (error instanceof AxiosError) {
                showToast(`Ошибка версии: ${error.response?.data?.message}` || "Ошибка сети");
            } else if (error instanceof Error) {
                showToast(`Ошибка версии: ${error.message}`);
            } else {
                showToast("Неизвестная ошибка при версии");
            }
        }
    }, [store]);

    useEffect(() => {
        fetchVersion();
    }, [fetchVersion]);

    const handleLogout = useCallback(async () => {
        try {
            const success = await store.logout();
            if (success) {
                navigate("/login");
            } else {
                console.error("Logout failed");
            }
        } catch (error) {
            console.error("Logout failed", error);
        }
    }, [store, navigate]);

    const handleFeedbackClick = useCallback(() => {
        navigate("/feedback");
    }, [navigate]);

    const menuItems = [
        {
            key: "settings",
            onClick: onSettingsClick,
            className: "settings-img",
            text: "Настройки"
        },
        {
            key: "password",
            onClick: onPasswordChangeClick,
            className: "change-password-img",
            text: "Смена пароля"
        },
        {
            key: "feedback",
            onClick: handleFeedbackClick,
            className: "feedback-img",
            text: "Обратная связь"
        }
    ];

    return (
        <div className="settings-popup-container" ref={outsideAlerterRef}>
            <div className="settings-popup-block">
                <div className="settings-user-info">
                    <Avatar size={AvatarSize.s} userId={store.user.id} />
                    <span className="a_header_name_16 settings-popup-username">
                        {store.user.name} {store.user.surname}
                    </span>
                </div>
                {menuItems.map((item) => (
                    <button
                        key={item.key}
                        className="settings-popup-btn"
                        onClick={item.onClick}
                        type="button"
                    >
                        <div className={item.className} />
                        <p>{item.text}</p>
                    </button>
                ))}
                <ExitButton onClickFunc={handleLogout} />
            </div>
            <div className="settings-popup-version">
                <p>Версия: {version?.appVersion || "Загрузка..."}</p>
            </div>
        </div>
    );
};

export default SettingsPopup;